import { useState, useCallback } from 'react';
import { getApiClient } from '../api/apiClient';

const apiClientIdentity = getApiClient('identity');

const useUsers = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [totalCount, setTotalCount] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);

  // Accept a single object parameter for consistency
  const fetchUsers = useCallback(async (params = {}) => {
    try {
      setLoading(true);
      setError(null);
      const {
        fromDate = '',
        toDate = '',
        page = 1,
        limit: paramLimit = 10,
        sortBy = 'createdAt',
        sortOrder = 'desc',
      } = params;
      setCurrentPage(page);
      setLimit(paramLimit);
      const response = await apiClientIdentity.get('/users/allUsers', {
        params: {
          page,
          limit: paramLimit,
          fromDate,
          toDate,
          sortBy,
          sortOrder
        },
        withCredentials: true
      });
      if (response.data.success) {
        setUsers(response.data.data.items);
        setTotalCount(response.data.data.totalCount || 0);
        setTotalPages(response.data.data.totalPages || 1);
      }
    } catch (error) {
      setError(error.message);
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);
    }
  }, []);

  // Fetch a user by mobile number
  const fetchUserByMobile = useCallback(async (mobileNumber) => {
    try {
      setLoading(true);
      setError(null);
      const response = await apiClientIdentity.get(`/users/by-mobile`, {
        params: { mobileNumber },
        withCredentials: true
      });
      if (response.data.success && response.data.data) {
        setUsers([response.data.data]);
        setTotalCount(1);
      } else {
        setUsers([]);
        setTotalCount(0);
      }
    } catch (error) {
      setError(error.message);
      setUsers([]);
      setTotalCount(0);
      console.error('Error fetching user by mobile:', error);
    } finally {
      setLoading(false);
    }
  }, []);

  const getDateRange = (filter) => {
    const today = new Date();
    let fromDate = new Date();

    if (filter === 'week') {
      fromDate.setDate(today.getDate() - 7);
    } else if (filter === 'month') {
      fromDate.setMonth(today.getMonth() - 1);
    }

    return {
      fromDate: fromDate.toISOString().split('T')[0],
      toDate: today.toISOString().split('T')[0]
    };
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'Never';
    const date = new Date(dateString);
    return date.toLocaleString();
  };

  return {
    users,
    loading,
    error,
    fetchUsers,
    getDateRange,
    formatDate,
    totalCount,
    totalPages,
    currentPage,
    limit,
    setCurrentPage,
    setLimit,
    fetchUserByMobile
  };
};

export default useUsers; 